
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWindApparent5 as ObiWindApparent5Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-wind-apparent-5.js';
 
 
 

 
 export const ObiWindApparent5 = createComponent({
   react: React,
   tagName: 'obi-wind-apparent-5',
   elementClass: ObiWindApparent5Element,
   events: {
     
   }
  });
 
 